import { CLASS_NAMES } from './Option-constants';

interface ViewComponentProps {
  /**
   * Title
   */
  rateKey: string;
  /**
   * Icon
   */
  durations: string[];
}

const ViewComponent = ({ rateKey, durations }: ViewComponentProps) => (
  <div className={CLASS_NAMES.container}>
    <p className={CLASS_NAMES.title}>{rateKey}</p>
    <div className={CLASS_NAMES.bullet} />
    <p className={CLASS_NAMES.title}>{`${durations.join(', ')} months`}</p>
  </div>
);

ViewComponent.displayName = 'PaymentMethods-Option-view';

export default ViewComponent;
